import React, { useEffect, useState } from 'react';
import Confetti from 'react-confetti';
import { useLocation } from 'react-router-dom';

import { useLocalStorage } from '../../hooks/useLocalStorage';

function PageEffects() {
  const location = useLocation();

  // milestone contracts confetti effect
  const contractId = location.pathname.match(/\/admin\/contracts\/([0-9]+)/)?.[1];
  const contractNumber = parseInt(contractId, 10);
  // limit confetti to 3 times per milestone
  const confettiLimit = 3;
  const [confettiEnabled, setConfettiEnabled] = useState(false);
  const [confettiRecycles, setConfettiRecycles] = useState(true);
  // confetti count for milestones are stored in an object like {30000: 3, 35000: 2, 40000: 3}
  const [hasSeenConfettiCount, setHasSeenConfettiCount] = useLocalStorage('hasSeenConfettiCount', {});
  // enables confetti component for 20 seconds
  useEffect(() => {
    if (
      contractId &&
      contractNumber % 5000 === 0 &&
      (!hasSeenConfettiCount[contractId] || hasSeenConfettiCount[contractId] <= confettiLimit)
    ) {
      setConfettiEnabled(true);
      setTimeout(() => {
        setConfettiRecycles(false);
      }, 12000);
      setTimeout(() => {
        setHasSeenConfettiCount(hasSeenConfettiCount + 1);
        // increment confetti count for specific milestone
        setHasSeenConfettiCount({
          ...hasSeenConfettiCount,
          [contractId]: hasSeenConfettiCount[contractId] ? hasSeenConfettiCount[contractId] + 1 : 1,
        });
        setConfettiEnabled(false);
      }, 20000);
    }
  }, [location, contractId, contractNumber, hasSeenConfettiCount, setHasSeenConfettiCount]);

  return confettiEnabled && <Confetti recycle={confettiRecycles} />;
}

export default PageEffects;
